import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { stringToNumberConverter } from 'src/app/product-capture/utils/string-to-number-converter';

export function minMaxRangeValidator(
  minControl: string | null,
  maxControl: string | null
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let minValue = stringToNumberConverter(control.get(minControl).value);
    let maxValue = stringToNumberConverter(control.get(maxControl).value);

    if (!!minValue && !!maxValue && minValue > maxValue) {
      control.get(minControl).setErrors({
        incorrect: true,
        message: 'Minimum must be less than or equal to Maximum',
      });
      control.get(maxControl).setErrors({
        incorrect: true,
        message: 'Maximum must be greater than or equal to Minimum',
      });
      return { incorrect: true };
    }

    if (!!minValue && !!maxValue && minValue <= maxValue) {
      control.get(minControl).setErrors(null);
      control.get(maxControl).setErrors(null);
      return null;
    }

    if (!!minValue || !!maxValue) {
      control.get(minControl).setErrors(null);
      control.get(maxControl).setErrors(null);
      return null;
    }

    return null;
  };
}
